import { render, staticRenderFns } from "./search-order.vue?vue&type=template&id=02040f1a&scoped=true"
import script from "./search-order.vue?vue&type=script&lang=js"
export * from "./search-order.vue?vue&type=script&lang=js"
import style0 from "./search-order.vue?vue&type=style&index=0&id=02040f1a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02040f1a",
  null
  
)

export default component.exports